import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";

const fetch = (): AxiosPromise<InvitedNotLoggedStudentApi[]> => {
  return api.get<InvitedNotLoggedStudentApi[]>(endpoints.INVITED_STUDENTS.GET_NOT_LOGGED());
};

const sendReminders = (studentIds: string[]): AxiosPromise<void> => {
  return api.post<void>(endpoints.INVITED_STUDENTS.SEND_REMINDERS(), { studentIds });
};
export const invitedStudentsApi = {
  fetch,
  sendReminders,
};

export interface InvitedNotLoggedStudentApi {
  userId: number;
  email: string;
  emails: [
    {
      emailId: number;
      createdDate: Date;
    },
  ];
}
